module.exports = __webpack_public_path__ + "static/media/STANDARD.687fda37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rooms/STANDARD.jpg
// module id = 1157
// module chunks = 0